import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import Vision from "@/components/Vision";
import Offerings from "@/components/Offerings";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import VoresTilgang from "@/pages/VoresTilgang";
import ViTilbyder from "@/pages/ViTilbyder";
import ServicePage from "@/pages/ServicePage";
import Viden from "@/pages/Viden";
import OmOs from "@/pages/OmOs";
import Ressourcer from "@/pages/Ressourcer";
import RessourceKategori from "@/pages/RessourceKategori";
import Privatlivspolitik from "@/pages/Privatlivspolitik";
import CookieConsent from "@/components/CookieConsent";
import Implementering from "@/pages/ydelser/Implementering";
import Kurser from "@/pages/ydelser/Kurser";
import Supervision from "@/pages/ydelser/Supervision";

export const scrollToSection = (selector) => {
  const el = document.querySelector(selector);
  if (!el) {
    window.location.href = `/${selector}`;
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.8 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const Home = () => (
  <main>
    <Hero />
    <Story />
    <Vision />
    <Offerings />
    <Contact />
  </main>
);

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToSection(hash), 400);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App overflow-x-clip bg-[#FAF7F1] font-sans text-[#2F3338] antialiased">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vores-tilgang" element={<VoresTilgang />} />
          <Route path="/viden" element={<Viden />} />
          <Route path="/ressourcer" element={<Ressourcer />} />
          <Route path="/ressourcer/:slug" element={<RessourceKategori />} />
          <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/vi-tilbyder" element={<ViTilbyder />} />
          <Route path="/vi-tilbyder/implementering" element={<Implementering />} />
          <Route path="/vi-tilbyder/kurser" element={<Kurser />} />
          <Route path="/vi-tilbyder/supervision" element={<Supervision />} />
          <Route path="/vi-tilbyder/:slug" element={<ServicePage />} />
        </Routes>
        <Footer />
        <CookieConsent />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
